import { useTranslation } from 'react-i18next';
import styled from 'libs/styled';
import { above } from '@sportson/core-web/utils/mediaqueries';

import Text from 'components/Text';
import Column from '@sportson/core-web/App/layouts/Column';
import Accordion from 'components/productPage/accordions/Accordion';

const Table = styled('table')`
    width: 100%;

    thead {
        text-align: left;
        text-transform: capitalize;
        p {
            margin-bottom: 8px;
        }
    }
    tbody {
        display: flex;
        flex-direction: column;
        row-gap: 16px;

        tr {
            display: flex;
            flex-direction: column;
            gap: 24px;
            width: 100%;
            padding: 8px 0;
            justify-content: space-between;

            ${above['tablet.sm']} {
                border-bottom: 1px solid var(--color-neutrals-200);
                flex-direction: row;
            }
        }
    }
`;

const StyledTd = styled('td')`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    border-bottom: 1px solid var(--color-neutrals-200);

    p:last-child {
        padding-bottom: 4px;
    }

    ${above['tablet.sm']} {
        border-bottom: none;

        p:last-child {
            padding-bottom: 0px;
        }
    }
`;

export const Parametrics = ({ parametrics }) => {
    const { t } = useTranslation();

    const getUniqueParametricsGroupsAndIds = (parametrics) => {
        // If groupName === null, then create a group with id = 0 and name = general else sort out unique grpName and groupIds
        const uniqueGroups = parametrics.reduce((acc, parametric) => {
            const { groupName, groupId } = parametric;
            if (groupName === null && groupId === 0) {
                acc.general = groupId;
                return acc;
            }
            if (!acc[groupName]) {
                acc[groupName] = groupId;
            }
            return acc;
        }, {});

        return Object.entries(uniqueGroups).map(([name, id]) => ({ name, id }));
    };

    const renderValue = (value, value2) => {
        if (value || value2) {
            // TODO: is value supposed to return "True" as a string or true?
            if (value === 'True' || value2 === 'True') {
                return t('pdp.info.yes');
            }
            if (value === false || value2 === false) {
                return t('pdp.info.no');
            }
            return value || value2;
        }
        return '';
    };

    const parametricsGroups = getUniqueParametricsGroupsAndIds(parametrics);

    return (
        <Accordion label={t('pdp.info.parametrics')}>
            <Column gap={['32px', null, null, '80px']} width="100%" alignItems="center">
                {parametricsGroups.map(({ name, id }) => (
                    <Table key={`name-${id}`} typography="UI">
                        <thead>
                            <tr>
                                <th>
                                    <Text typography="UI/20_100_0_450" color="var(--text-color-default)">
                                        {name === 'general' ? t('pdp.info.general') : name}
                                    </Text>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {parametrics
                                .filter(
                                    (parametric) =>
                                        parametric.isHidden === false &&
                                        parametric.groupId === id &&
                                        parametric.value !== null &&
                                        parametric.value2 !== null &&
                                        parametric.value !== '' &&
                                        parametric.value2 !== '',
                                )
                                .sort((a, b) => a.name.localeCompare(b.name))
                                .reduce((chunks, parametric, index, array) => {
                                    if (index % 2 === 0) {
                                        chunks.push(array.slice(index, index + 2));
                                    }
                                    return chunks;
                                }, [])
                                .map((chunk, index) => (
                                    <tr key={`chunk-${index}`}>
                                        {chunk.map(({ name, value, value2 }) => (
                                            <StyledTd key={name}>
                                                <Text
                                                    color="var(--color-neutrals-400-darker)"
                                                    typography="UI/12_100_0_450_uppercase"
                                                >
                                                    {name}
                                                </Text>
                                                <Text color="var(--text-color-default)" typography="UI/14_100_0_450">
                                                    {renderValue(value, value2)}
                                                </Text>
                                            </StyledTd>
                                        ))}
                                    </tr>
                                ))}
                        </tbody>
                    </Table>
                ))}
            </Column>
        </Accordion>
    );
};
